import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import 'react-photo-view/dist/react-photo-view.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ColorModeScript } from '@chakra-ui/react';
import theme from './theme';
import { preventMobileZoom } from './util/preventMobileZoom';
import { registerServiceWorker } from './registerServiceWorker';

preventMobileZoom();
registerServiceWorker();

const clientId = "448650598086-2i5kerin87g66difhpi9ql6cir9jvh8f.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={clientId}>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </GoogleOAuthProvider>
);

reportWebVitals();
